import React, { useEffect, useState, Children, ReactElement, cloneElement } from "react";
import classNames from "classnames";
import { getOtherProperties } from "../common/Utils";
import { ButtonNavigationProps } from "./PropsType";

export default function ButtonNavigation(props: ButtonNavigationProps) {
  const {
    className,
    children: childrenProps,
    fixed = true,
    prefixCls = "bm-ButtonNavigation",
    ...other
  } = props;
  const styleClass = classNames(
    prefixCls,
    {
      [`${prefixCls}-fixed`]: fixed,
    },
    className
  );
  const otherProps = getOtherProperties(other, [
    "activeIndex",
    "onChange",
    "value",
    "fixed",
  ]);

  const [activeIndex, setActiveIndex] = useState(
    typeof props.activeIndex! === "number" ? props.activeIndex : 0
  );

  const handleClick = (index: number, event: any) => {
    if (props.onChange) {
      (props.onChange as (event: any) => void)({
        originalEvent: event,
        index,
      });
    }
    setActiveIndex(index);
  };

  const children = Children.map(
    childrenProps,
    (child: ReactElement<any>, index: number) => {
      const props: any = { ...(child.props || {}) };
      props.active = index === activeIndex!;
      props.onClick = handleClick.bind(null, index);
      return cloneElement(child, props);
    }
  );

  useEffect(() => {
    if (typeof props.activeIndex === "number") {
      setActiveIndex(props.activeIndex || 0);
    }
  }, [props.activeIndex]);

  return (
    <div className={styleClass} {...otherProps}>
      {children}
    </div>
  );
}
